import React, {useEffect, useState} from "react";
import "./../../utils/Style/pages/Banktransfers.scss";
import useCommonAPI from "../../api/CommonAPI";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useDispatch, useSelector} from "react-redux";
import {useOutletContext} from "react-router-dom";
import BlurLoading from "../../components/BlurLoading";
import {parseFormattedNumber} from "../../features/ValueFormater";
import NumberInput from "../../components/BankTransfers/NumberInput";


function SendPaymentRequest() {
    const [selectedFile, setSelectedFile] = useState();
    const [payload, setPayload] = useState({
        CurrencyID: "",
        PhoneNumber: "",
        Amount: "",
        BranchName: ""
    });

    const [errors, setErrors] = useState({});

    const {getAllCurrencies, currencies} = useCommonAPI();

    const {branches} = useSelector((state) => state.branches);

    const [onOpenQrAfterGenerate] = useOutletContext();
    const dispatch = useDispatch();

    useEffect(() => {
        getAllCurrencies();
    }, []);


    const handleChange = (event) => {
        const {name, value} = event.target;
        setPayload({...payload, [name]: value});
        setErrors({...errors, [name]: ""});
    };

    const handleChangeAmount = (event) => {
        setPayload({...payload, Amount: parseFormattedNumber(event.target.value)});
    }


    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!payload.CurrencyID || payload.CurrencyID==="0") {
            newErrors.CurrencyID = "Currency is required.";
            isValid = false;
        }

        if (!payload.PhoneNumber) {
            newErrors.PhoneNumber = "Phone Number is required.";
            isValid = false;
        }

        if (!payload.Amount) {
            newErrors.Amount = "Amount is required.";
            isValid = false;
        } else if (isNaN(payload.Amount)) {
            newErrors.Amount = "Amount must be a number.";
            isValid = false;
        } else if (payload.Amount <= 0) {
            newErrors.Amount = "Amount must be a positive number.";
            isValid = false;
        }

        if (!payload.BranchName) {
            newErrors.BranchName = "Branch is required.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (validateForm()) {
            dispatch(setActionType(ACTION_TYPES.INITIATE_PAYMENT_REQUEST));
            dispatch(setActionPayload(payload));

            onOpenQrAfterGenerate();
        }
    };

    return (
        <>
            <div className="NewTransferTemplate">
                {<BlurLoading/>}

                <div className="title">Request money from</div>
                <form className="NewTransferTemplate" onSubmit={handleSubmit} autoComplete="off">
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Phone Number</div>
                        <div className="col-lg-6 col-md-7">
                            <input
                                type="number"
                                name="PhoneNumber"
                                placeholder="Phone Number"
                                value={payload.PhoneNumber}
                                onChange={handleChange}
                            />
                            {errors.PhoneNumber && (
                                <span className="error">{errors.PhoneNumber}</span>
                            )}
                        </div>
                    </div>

                    <div className="title">Send payment request from</div>

                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Branch</div>
                        <div className="col-lg-6 col-md-7">
                            <select
                                className={!payload.BranchName? "placeholder-color ddselect": "ddselect"}
                                name="BranchName"
                                id="account"
                                value={payload.BranchName}
                                onChange={handleChange}
                            >
                                <option value="">Select one value Only</option>
                                {
                                    branches && branches.map(({BranchID, Name}) => (
                                        <option key={BranchID} value={Name}>{Name}</option>
                                    ))
                                }
                            </select>
                            {errors.BranchName && (
                                <span className="error">{errors.BranchName}</span>
                            )}
                        </div>
                    </div>

                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Currency</div>
                        <div className="col-lg-6 col-md-7">
                            <select
                                className={!payload.CurrencyID || payload.CurrencyID==="0"? "placeholder-color ddselect": "ddselect"}
                                name="CurrencyID"
                                id="account"
                                value={payload.CurrencyID}
                                onChange={handleChange}
                            >
                                <option value="0">Select one value Only</option>
                                {currencies && currencies.map(({label, value}) => (
                                    <option key={value} value={value}>{label}</option>
                                ))
                                }
                            </select>
                            {errors.CurrencyID && (
                                <span className="error">{errors.CurrencyID}</span>
                            )}
                        </div>
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Amount</div>
                        <div className="col-lg-6 col-md-7">
                            <NumberInput payload={payload} setPayload={setPayload} currency={payload.CurrencyID} objKey="Amount"/>
                            {errors.Amount && <span className="error">{errors.Amount}</span>}
                        </div>
                    </div>

                    <div className="row submitForm">
                        <div className="btn_place">
                            <button type="submit" className="submitBtn" onClick={handleSubmit}>Confirm</button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default SendPaymentRequest;


